import { useState } from 'react';
import './Accordion.css';
import ChevronDownIcon from '../../assets/icons/chevron-down.svg?react';
const Accordion = ({ 
  items = [], 
  defaultOpenIndex = 0,
  onItemClick = () => {},
  selectedItemId = null,
  className = '',
  style = {}
}) => {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  const handleItemClick = (item, itemIndex) => {
    onItemClick(item, itemIndex);
  };

  return (
    <div className={`accordion ${className}`} style={style}>
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        
        return (
          <div key={item.id || index} className="accordion-item">
            {/* 헤더 */}
            <div 
              className="accordion-header"
              onClick={() => handleToggle(index)}
            >
              <div className={`accordion-chevron ${isOpen ? 'open' : ''}`}>
                <ChevronDownIcon/>
              </div>
              <div className="accordion-header-content">
                <span className={`accordion-title ${isOpen ? 'open' : ''}`}>{item.title}</span>
              </div>
              {item.count !== undefined && item.count !== null && (
                <span className="accordion-badge">{item.count}</span>
              )}
            </div>

            {/* 콘텐츠 */}
            {isOpen && item.content !== undefined && item.content !== null && (
              <div className="accordion-content accordion-content--custom">
                {item.content}
              </div>
            )}
            {isOpen && item.content === undefined && item.children && (
              <div className="accordion-content">
                {item.children.map((child, childIndex) => (
                  <div 
                    key={child.id || childIndex}
                    className={`accordion-child-item ${selectedItemId === child.id ? 'selected' : ''}`}
                    onClick={() => handleItemClick(child, childIndex)}
                  >
                    <div className="accordion-child-content">
                      <span className={`accordion-child-title ${selectedItemId === child.id ? 'selected' : ''}`}>{child.title}</span>
                      {child.subtitle && (
                        <span className="accordion-child-subtitle">{child.subtitle}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
